import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getRelativeTime } from "utils";
import { useGetQuery } from "hooks";
import { Button, Card, Icon, Paginate, Row, Table } from "components";

export const AdminUsers = () => {
  const [page, setPage] = useState({ page: 1, limit: 5 });
  const navigate = useNavigate();

  const { data, setPath } = useGetQuery({
    url: `/admin/users?limit=${page.limit}&offset=${
      (page.page - 1) * page.limit
    }`,
  });

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setPath(
      `/admin/users?limit=${newPage.limit}&offset=${
        (newPage.page - 1) * newPage.limit
      }`
    );
  };

  return (
    <Card>
      <Table
        data={data?.users?.rows || []}
        columns={[
          {
            title: "Email",
            key: "email",
          },
          {
            title: "Last Login",
            key: "updatedAt",
            render: (time) => {
              return getRelativeTime(time);
            },
          },
          {
            title: "Actions",
            key: "slug",
            className: "right",
            render: (slug) => {
              return (
                <>
                  <Link to={`/admin/users/${slug}`}>
                    <Icon icon="account" />
                  </Link>{" "}
                  <Link to={`/admin/users/${slug}/edit`}>
                    <Icon icon="account-edit" />
                  </Link>
                </>
              );
            },
          },
        ]}
      />
      <Row>
        <Paginate
          {...page}
          count={data?.users?.count || 0}
          onChange={handlePageChange}
        />
        <Button className="large" onPress={() => navigate("/admin/users/new")}>
          New
        </Button>
      </Row>
    </Card>
  );
};
